import BaseEnum from '@linc-technologies/linced-common/enums/base-enum';

export default BaseEnum.create({
  values: [
    { value: 1, label: 'Community Notice' },
    { value: 2, label: 'Staff Notice' },
    { value: 3, label: 'Global Notice' },
    { value: 4, label: 'Text Notice' },
    { value: 5, label: 'Post' },
    { value: 6, label: 'Billing Statement' },
    { value: 7, label: 'Absence Alert' },
  ],
});
